import { z } from "zod";

const optionalString = z.string().min(1).optional();

export const rootEnvSchema = z.object({
  DATABASE_URL: z.string().min(1),
  REDIS_URL: z.string().min(1),
  SEPAY_MERCHANT_ID: optionalString,
  SEPAY_SECRET_KEY: optionalString,
  SEPAY_IPN_URL: optionalString,
  SEPAY_IPN_SECRET_KEY: optionalString,
  SEPAY_RETURN_URL: optionalString,
  SEPAY_CANCEL_URL: optionalString,
  SEPAY_ERROR_URL: optionalString,
  CASSO_WEBHOOK_SECRET: optionalString,
  CASSO_API_KEY: optionalString,
  CASSO_BANK_ACC_ID: optionalString,
  VIETQR_CLIENT_ID: optionalString,
  VIETQR_API_KEY: optionalString,
  VIETQR_ACCOUNT_NO: optionalString,
  VIETQR_ACCOUNT_NAME: optionalString,
  VIETQR_ACQ_ID: optionalString,
  VIETQR_TEMPLATE: optionalString,
  ESMS_API_KEY: optionalString,
  ESMS_SECRET_KEY: optionalString,
  ESMS_BRANDNAME: optionalString,
  ESMS_SMS_TYPE: optionalString,
  JWT_ACCESS_SECRET: optionalString,
  JWT_REFRESH_SECRET: optionalString,
  ENCRYPTION_KEY_V1: optionalString,
  R2_ACCOUNT_ID: optionalString,
  R2_ACCESS_KEY_ID: optionalString,
  R2_SECRET_ACCESS_KEY: optionalString,
  R2_BUCKET: optionalString,
  R2_PUBLIC_BASE: optionalString,
  SENTRY_DSN_API: optionalString,
  SENTRY_DSN_WEB: optionalString,
  AXIOM_TOKEN: optionalString,
  API_BASE_URL: z.string().min(1),
  WEB_BASE_URL: z.string().min(1),
});

export type RootEnv = z.infer<typeof rootEnvSchema>;

type EnvMap = Record<string, string | undefined>;

function defaultProcessEnv(): EnvMap {
  const proc = (globalThis as { process?: { env?: EnvMap } }).process;
  return proc?.env ?? {};
}

export function parseRootEnv(env: EnvMap = defaultProcessEnv()): RootEnv {
  return rootEnvSchema.parse(env);
}
